<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-hide-separate-window`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M44 6a2 2 0 012 2v32a2 2 0 01-2 2H4a2 2 0 01-2-2V8a2 2 0 012-2h40zm-26 4H6v28h36V26H20.333C19.05 26 18 25.006 18 23.778V10zm4 0h20v12H22V10z"/></svg>
</template>
<script>

export default {
  name: 'IconHideSeparateWindow',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
